import { render, staticRenderFns } from "./PgaOfferEvaluationTotalsOfferEvaluationCreate.vue?vue&type=template&id=0dc652e0&"
import script from "./PgaOfferEvaluationTotalsOfferEvaluationCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationTotalsOfferEvaluationCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc652e0')) {
      api.createRecord('0dc652e0', component.options)
    } else {
      api.reload('0dc652e0', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationTotalsOfferEvaluationCreate.vue?vue&type=template&id=0dc652e0&", function () {
      api.rerender('0dc652e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/create/sub-components/PgaOfferEvaluationTotalsOfferEvaluationCreate.vue"
export default component.exports